import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

export function Redirect({ to }: { to: string }) {
  const { storeKey = "" } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/stores/${storeKey}/${to}`);
  }, [navigate, storeKey, to]);

  return null;
}
